const Loader = () => {
    return (
        <div className="h-screen w-screen flex items-center justify-center">
            <h1 className="font-bold text-2xl">Loading...</h1>
        </div>
    )
}; export default Loader